import { envType } from '@atlassiansox/analytics-web-client';

import { EMBEDDED_CONFLUENCE_MODE } from '@atlassian/embedded-confluence';

export const onEditMode = (
	mode: EMBEDDED_CONFLUENCE_MODE,
	setPanelWidth: (width: number) => void,
) =>
	mode === EMBEDDED_CONFLUENCE_MODE.EDIT_MODE
		? setPanelWidth(Math.floor(window.innerWidth / 2))
		: {};

export const getAnalyticsEnv = (hostname: string) => {
	if (hostname.includes('localhost')) {
		return envType.LOCAL;
	}
	if (hostname.includes('jira-dev')) {
		return envType.DEV;
	}

	return envType.PROD;
};
